// extracted by mini-css-extract-plugin
module.exports = {"userIconWrapper":"UserMenu_userIconWrapper__otilA","loginContainer":"UserMenu_loginContainer__kcmYm"};